import { cva } from 'class-variance-authority';

export const SELECT_VARIANTS = cva('flex flex-col gap-2 w-60', {
  variants: {
    variant: {
      default:
        'text-body-sm [&_[data-slot=select-label]]:text-body-sm [&_[data-slot=select-bottom-text]]:text-body-xs [&_[data-slot=select-trigger]]:h-10',
      lg: 'text-body-base [&_[data-slot=select-label]]:text-body-base [&_[data-slot=select-bottom-text]]:text-body-sm [&_[data-slot=select-trigger]]:h-12',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const SELECT_CONTENT_VARIANTS = cva(
  'max-h-[var(--radix-select-content-available-height)] bg-neutral-0 text-neutral-9 border-neutral-4 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md dark:bg-neutral-10 dark:text-neutral-0 dark:border-neutral-8',
  {
    variants: {
      variant: {
        default: 'text-body-sm [&_[data-slot=select-item]]:h-10',
        lg: 'text-body-base [&_[data-slot=select-item]]:h-12',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
